import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Get_in_touch from "./components/get_in_touch/Get_in_touch";
import About_us from "./components/about_us/About_us";
import Products from "./components/products/Products";
import Product_details from "./components/product_details/Product_details";
import Contact from "./components/contact/Contact";
import Terms_and_condition from "./components/terms_and_condition/Terms_and_condition";
import Privacy_Policy from "./components/privacy_Policy/Privacy_Policy";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productId" element={<Product_details />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-condition" element={<Terms_and_condition />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
      </Routes>
      <Get_in_touch />
      <Footer />
    </>
  );
}

export default App;
